module.exports = __webpack_public_path__ + "img/g0037.1a7772cd.png";